// Generic skeleton placeholder. Use while async data is loading so the
// page reserves its final layout instead of flashing "Loading…" text.
//
// Usage:
//   ListLoading: {
//     extends: 'Skeleton',
//     width: '100%', height: 'A',  // override size to match final content
//     round: 'Y'
//   }
//
//   Plus the SkeletonRow / SkeletonCircle helpers for common shapes.
//
// Animation: subtle shimmer using the `pulse` keyframe defined in
// brand. Respects `prefers-reduced-motion: reduce` automatically via
// the framework's media-query handling.

export const Skeleton = {
  display: 'block',
  width: '100%',
  height: 'V',
  round: 'V',
  background: 'overlay',
  // shimmer animation — gentle 1.5s loop
  animation: 'pulse 1.5s ease-in-out infinite',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    opacity: '0.6'
  }
}

// One-line text placeholder. Stack multiple to fake a paragraph.
export const SkeletonRow = {
  extends: 'Skeleton',
  height: 'V'
}

// Avatar / icon placeholder.
export const SkeletonCircle = {
  extends: 'Skeleton',
  width: 'B',
  height: 'B',
  round: '50%'
}

// Card-shaped placeholder — title + 2 lines.
export const SkeletonCard = {
  flow: 'y',
  gap: 'V',
  padding: 'A',
  round: 'Z',
  background: 'overlay',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'line',

  Title: { extends: 'SkeletonRow', width: '60%', height: 'V1' },
  Line_1: { extends: 'SkeletonRow', width: '100%' },
  Line_2: { extends: 'SkeletonRow', width: '80%' }
}
